export const tabsValues = {
  public: 'public',
  private: 'private'
}